module.exports = __webpack_public_path__ + "static/media/good.408a56e3.svg";